<template>
  <div class="page">
    <h1>Sender Aliases</h1>

    <div class="card">
      <p>
        Sender Alias feature is successfully loaded.
      </p>

      <button @click="loadAliases">
        Load Sender Aliases
      </button>

      <pre>{{ aliases }}</pre>
    </div>
  </div>
</template>

<script>
import MessageAPI from 'dashboard/api/inbox/message';

export default {
  data() {
    return {
      aliases: [],
    };
  },

  methods: {
    async loadAliases() {
      try {
        const response = await MessageAPI.getSenderAliases(
          this.$route.params.accountId
        );

        this.aliases = response.data;
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>